import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchWorkspaceAsync,
  removeWorkspace,
} from "src/features/performanceManagement/workspaceSlice";
import WorkspaceItem from "./components/WorkspaceItem";

const Workspace = () => {
  const dispatch = useDispatch();
  const { data, status } = useSelector((state) => state.workspace);

  useEffect(() => {
    dispatch(fetchWorkspaceAsync());
  }, []);

  function handleRemove(id) {
    dispatch(removeWorkspace(id));
  }

  return (
    <div className="p-5">
      {status === "loading" ? (
        <>Loading...</>
      ) : data && data.length > 0 ? (
        <>
          {data.map((item) => (
            <div key={item._id}>
              <WorkspaceItem data={item} handleRemove={handleRemove} />
            </div>
          ))}
        </>
      ) : (
        <>No Data</>
      )}
    </div>
  );
};

export default Workspace;
